import { Component, Input } from '@angular/core';
import { DataFieldGroup } from '@models/settings/data-field-group.model';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-field-group-form',
    templateUrl: './field-group.template.html',
    styleUrls: ['./field-group.style.scss'],
})
export class FieldGroupForm extends BaseForm {
    @Input() fieldGroup: DataFieldGroup = new DataFieldGroup();

    get areInputsDisabled(): boolean {
        return this.fieldGroup.isPersisted && this.fieldGroup.isDefault;
    }

    get areInputsRequired(): boolean {
        return !this.fieldGroup.isPersisted || this.fieldGroup.isCustom;
    }
}
